module.exports = __webpack_public_path__ + "img/agency-bob-growth.8036afe9.svg";